import axios from "axios";

// volá stejné origin (www.mojebingo.cz), jen relativně
const API_BASE = ""; // nebo např. const API_BASE = "/api";

export async function createGame(words) {
  const res = await axios.post(`${API_BASE}/api/games`, { words });
  return res.data;
}

export async function joinGame(gameId, name) {
  const res = await axios.post(`${API_BASE}/api/games/${gameId}/join`, { name });
  return res.data;
}

export async function fetchScoreboard(gameId) {
  const res = await axios.get(`${API_BASE}/api/games/${gameId}/scoreboard`);
  return res.data;
}
